"use client";

import React from "react";

import { dictionaries } from "@/dictionaries/content";

import { ClusterSelectionSummary } from "../cluster-selection/cluster-selection-summary";

interface ZonesSummaryProps {
  zonesCount: number;
  unassignedCount: number;
}

const ZonesSummaryComponent: React.FC<ZonesSummaryProps> = ({ zonesCount, unassignedCount }) => {
  return (
    <ClusterSelectionSummary
      metrics={[
        {
          label: dictionaries.mapPage.zonesPanel.zones,
          value: zonesCount,
          icon: <span className="h-6 w-6 shrink-0" />,
        },
        {
          label: dictionaries.mapPage.zonesPanel.unassigned,
          value: unassignedCount,
          icon: <span className="h-6 w-6 shrink-0" />,
        },
      ]}
    />
  );
};

export const ZonesSummary = React.memo(ZonesSummaryComponent);
